// Stat card component
const StatCard = ({ label, percentage, made, total, color, width }) => {
	const progressPercentage = total > 0 ? (made / total) * 100 : 0;

	return (
		<div
			className={`flex flex-col items-start justify-start ${
				width ? `w-[${width}px]` : "w-full flex-1"
			}`}
		>
			<div className="mb-1 flex w-full items-end justify-between">
				<div className="font_['SF Pro'] text-sm font-medium leading-[1.35] text-[#999999]">
					{label}
				</div>
				<div className="flex items-baseline">
					<span className="font_['SF Pro'] text-xl font-bold leading-[1.35] text-[#404040]">
						{percentage}
					</span>
					<span className="font_['SF Pro'] text-base font-bold leading-[1.35] text-[#404040]">
						%
					</span>
				</div>
			</div>
			<div className="relative flex h-4 w-full items-center justify-center overflow-hidden rounded bg-[#DFDFDF]">
				<div
					className="absolute -left-[0.01rem] -top-[0.01rem] h-full rounded"
					style={{
						width: `${progressPercentage}%`,
						background: color,
					}}
				/>
				<div className="relative z-10 font_['SF Pro'] text-xs font-medium leading-[1.35] text-white">
					{made}/{total}
				</div>
			</div>
		</div>
	);
};

// Main component
export const SpotViewBottom = ({
	FGPercentage = 45,
	FGMade = 45,
	FGTotal = 100,
	TPPercentage = 23,
	TPMade = 23,
	TPTotal = 100,
	FTPercentage = 82,
	FTMade = 82,
	FTTotal = 100,
}) => {
	const unifiedColor = "#6B7BE8";

	const stats = [
		{
			label: "FG%",
			percentage: FGPercentage,
			made: FGMade,
			total: FGTotal,
			color: unifiedColor,
			width: null,
		},
		{
			label: "3P%",
			percentage: TPPercentage,
			made: TPMade,
			total: TPTotal,
			color: unifiedColor,
			width: null,
		},
		{
			label: "FT%",
			percentage: FTPercentage,
			made: FTMade,
			total: FTTotal,
			color: unifiedColor,
			width: null,
		},
	];

	return (
		<div className="box-border w-full bg-white px-4 pb-4">
			<div className="mb-3 text-left font_['SF Pro'] text-lg font-[590] leading-[1.2] tracking-[-0.5px] text-[#404040]">
				Overall Shooting Data
			</div>
			<div className="box-border flex w-full items-center justify-between gap-4 rounded-lg bg-[#F5F5F5] px-4 py-3">
				<StatCard {...stats[0]} />
				<div className="h-[46px] w-px bg-[#BBBBBB]" />
				<StatCard {...stats[1]} />
				<div className="h-[46px] w-px bg-[#BBBBBB]" />
				<StatCard {...stats[2]} />
			</div>
		</div>
	);
};
